<template>
  <div class="catzum-component-container">
    <h2>{{ headingText }}</h2>
    <p>{{ bodyText }}</p>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    headingText: String,
    bodyText: String
  }
})
export default class CatzumComponent extends Vue {
  headingText = "";
  bodyText = "";

  
}
</script>

<style scoped>
.catzum-component-container {
  font-family: Arial, Helvetica, sans-serif;
  padding: 40px;
  background-color: green;
  
}
p, h2 {
  color: white;
}
</style>
